<div class="app-card">
    <ng-content select="card-header"></ng-content>
    <div class="card-content">
      <ng-content></ng-content>
    </div>
</div>
